import { render, staticRenderFns } from "./FrzCustomCardParihuelaChamber.vue?vue&type=template&id=e1416934"
import script from "./FrzCustomCardParihuelaChamber.vue?vue&type=script&lang=js"
export * from "./FrzCustomCardParihuelaChamber.vue?vue&type=script&lang=js"
import style0 from "./FrzCustomCardParihuelaChamber.vue?vue&type=style&index=0&id=e1416934&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports